<div class="month-sales">
  <div class="header">
    {{ label }}
  </div>

  <div class="total">
    {{ total }}
  </div>

  <i2g-router-link
    *ngIf="route"
    buttonStyle="tertiary"
    [label]="route.label | translate"
    [route]="route.route"
    class="link"
  >
  </i2g-router-link>
</div>
